import { render, staticRenderFns } from "./IndexUser.vue?vue&type=template&id=6cc7f9ee"
import script from "./IndexUser.vue?vue&type=script&lang=js"
export * from "./IndexUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports